import React from 'react';

const AboutPage: React.FC = () => {
  return (
    <div className="section">
      <div className="container">
        <h1 className="section-title">عن المعلمة</h1>
        
        <div className="card">
          <div className="card-content">
            <h3>مرحباً بكم في عالم تعلم اللغة الإنجليزية للأطفال</h3>
            <p>
              أنا معلمة متخصصة في تأسيس اللغة الإنجليزية للأطفال، وشغفي الأكبر هو مساعدة الأطفال على اكتشاف متعة تعلم اللغة الإنجليزية.
              أؤمن بأن كل طفل لديه قدرات فريدة وأسلوب تعلم خاص به، وأسعى دائماً لتقديم تجربة تعليمية ممتعة ومخصصة تناسب احتياجات كل طفل.
            </p>
            
            <h3>شغفي بتعليم الأطفال</h3>
            <p>
              منذ بداية مسيرتي في تعليم اللغة الإنجليزية، اكتشفت أن العمل مع الأطفال هو ما يملأني بالسعادة والرضا. 
              أحب رؤية عيونهم تلمع عندما يفهمون فكرة جديدة أو يتمكنون من التعبير عن أنفسهم باللغة الإنجليزية لأول مرة.
            </p>
            
            <h3>منهجي في التعليم</h3>
            <p>
              أعتمد في تدريسي على منهج تفاعلي يجمع بين:
            </p>
            <ul>
              <li>التعلم من خلال اللعب والأنشطة الممتعة</li>
              <li>استخدام القصص والأغاني لتعزيز المفردات والنطق</li>
              <li>أنشطة حركية تساعد على ترسيخ المعلومات</li>
              <li>تقنيات تعليمية حديثة تجذب انتباه الأطفال</li>
            </ul>
            
            <h3>هدفي</h3>
            <p>
              هدفي ليس فقط تعليم الأطفال قواعد اللغة الإنجليزية، بل غرس حب التعلم في نفوسهم وبناء ثقتهم بأنفسهم.
              أسعى لخلق بيئة تعليمية إيجابية يشعر فيها كل طفل بالأمان والتشجيع للتعبير عن نفسه والمشاركة بفعالية.
            </p>
            
            <h3>دعوة للانضمام</h3>
            <p>
              أدعوكم للانضمام إلى رحلتنا التعليمية الممتعة، حيث نبني معاً أساساً قوياً للغة الإنجليزية يستمر مع أطفالكم مدى الحياة.
              معاً، سنجعل تعلم اللغة الإنجليزية تجربة ممتعة ومثمرة لأطفالكم!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
